module.exports = __webpack_public_path__ + "static/media/eyewrap1.cb400bdb.jpg";